module.exports = __webpack_public_path__ + "static/media/LK_White_User.6342aa5a.svg";